import Polyglot from './polyglot';

const IDENT_RE = /^[a-zA-Z_][a-zA-Z0-9_]*$/;

function bindTranslate(poly) {
  return (key, second) => poly.t(key, second);
}

function installLocaleShortcut() {
  const cfg = window.__localeShortcutConfig || {};
  const localeFnByProduct = cfg.localeFnByProduct && typeof cfg.localeFnByProduct === 'object'
    ? cfg.localeFnByProduct
    : {};

  const byProduct = window.langByProduct;

  if (!byProduct || typeof byProduct !== 'object') {
    return;
  }

  Object.entries(localeFnByProduct)
    .filter(([name, fnName]) => IDENT_RE.test(fnName) && byProduct[name] && typeof byProduct[name] === 'object')
    .forEach(([name, fnName]) => {
      const poly = new Polyglot({ phrases: byProduct[name] });

      poly.locale('default');
      window[fnName] = bindTranslate(poly);
    });
}

export default installLocaleShortcut;
